// Calculate Size in KiloByte and MegaByte
export const calcSize = (size: number) => {
  const KiloByteBase = 1000;
  const KiloByteMax = 1000000;
  return size < KiloByteMax ? `${Math.floor(size / KiloByteBase)} KB` : `${Math.floor(size / KiloByteMax)} MB`;
};
